<ng-container *ngIf="reqst === 1">
    <div class="header-c">
        <strong>
            Ventas por Día
        </strong>
    </div>
    <div class="flex-right">
        <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" [callbackFunction]="chartCallbackHeatmap"
            style="width: 100%; height: 340px; display: block;">
        </highcharts-chart>
    </div>
</ng-container>

<div *ngIf="reqst === 0 " class="text-center loader-container">
    <div class="spinner-grow align-middle text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>